import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import type { ICategoryDataV3 } from '@df/catalog/category/category';
import type { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import type { IProductDataV3 } from '@df/catalog/product/product';
import type { IStoreDataV3 } from '@df/catalog/store/store';
import type { ICmsPageDecorator } from '../../cms/page/icms-page.decorator';
import { GiftcardsCategoryViewComponent } from '../../module/giftcards/giftcards-category-view.component';
import type { CategoryDecorator } from '../model/category/category.decorator';
import type { ProductDecorator } from '../model/product/product.decorator';
import type { StoreDecorator } from '../model/store/store.decorator';
import { CategoryViewComponent } from './category/category-view.component';
import { Error404Component } from './error-404.component';
import { PageViewComponent } from './page/page-view.component';
import { ProductViewComponent } from './product/view/product-view.component';
import { StoreViewComponent } from './store/view/store-view.component';

@Component({
    selector: 'catalog-view',
    templateUrl: 'catalog-view.html',
    standalone: true,
    imports: [
        CategoryViewComponent,
        Error404Component,
        GiftcardsCategoryViewComponent,
        PageViewComponent,
        ProductViewComponent,
        StoreViewComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogViewComponent extends CatalogViewComponentDef {
    protected getModelAsProduct(): ProductDecorator<IProductDataV3> {
        return this.model as ProductDecorator<IProductDataV3>;
    }

    protected getModelAsCategory(): CategoryDecorator<ICategoryDataV3> {
        return this.model as CategoryDecorator<ICategoryDataV3>;
    }

    protected getModelAsCmsPage(): ICmsPageDecorator<IPageDataV3> {
        return this.model as ICmsPageDecorator<IPageDataV3>;
    }

    protected getModelAsStore(): StoreDecorator<IStoreDataV3> {
        return this.model as StoreDecorator<IStoreDataV3>;
    }
}
